import React, { useRef } from 'react';
import dynamic from 'next/dynamic';
import { SlideProps } from 'react-slideshow-image';
import {
    isMobile,
    useWindowSize,
} from '@frontend/jetlend-web-ui/src/utils/responsive';
import OffscreenLoader from '@app/ui/OffscreenLoader/OffscreenLoader';
import styles from './CoursesSlider.module.scss';
import './slider.scss';

const LazySlide = dynamic(() => import('react-slick').then(module => module), { ssr: false });

const RESPONSIVE_SETTINGS = [
    {
        breakpoint: 1500,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: 1120,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
        },
    },
    {
        breakpoint: 568,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
        },
    },
];

/**
 * Компонент для отрисовки слайдера со всеми курсами
 */
const CoursesSlider = props => {
    const { children } = props;

    const sliderRef = useRef<SlideProps | null>(null);
    const { width: screenWidth } = useWindowSize();
    const isCenterMode = isMobile(screenWidth);

    const SLIDER_SETTINGS = {
        children: [],
        arrows: false,
        indicators: false,
        autoplay: false,
        infinite: false,
        duration: 1200,
        transitionDuration: 400,
        className: 'courses-slider',
        canSwipe: true,
        ref: sliderRef,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: RESPONSIVE_SETTINGS,
        centerMode: isCenterMode,
    };

    return (
        <OffscreenLoader>
            {({
                ref,
                inView,
            }) => (
                <div ref={ref} className={styles['container']}>
                    {inView && (
                        <LazySlide {...SLIDER_SETTINGS}>
                            {children?.map((child, i) => (
                                <React.Fragment key={i}>
                                    <div className={styles['item-wrapper']}>{child}</div>
                                </React.Fragment>
                            ))}
                        </LazySlide>
                    )}
                </div>
            )}
        </OffscreenLoader>
    );
};

export default CoursesSlider;